import * as React from 'react'

import ViewModeSelect from '~/client/src/shared/components/ViewModeSelect/ViewModeSelect'

import { useMobileResourceMeta } from '../context'

const noop = () => undefined

interface MobileResourceViewToggleProps {
  selectedViewMode?: string
  onSelectViewMode?: (mode: string) => void
}

export const MobileResourceViewToggle: React.FC<
  MobileResourceViewToggleProps
> = ({ selectedViewMode, onSelectViewMode }) => {
  const { viewModes } = useMobileResourceMeta()
  if (viewModes.length < 2) return null

  const resolvedMode = selectedViewMode || viewModes[0]?.mode || ''

  return (
    <ViewModeSelect
      value={resolvedMode}
      modes={viewModes}
      onChange={onSelectViewMode || noop}
    />
  )
}
